import React, { useEffect, useRef, useState } from "react";
import { useAppThunkDispatch } from "../../store/store";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { useSelector } from "react-redux";
import { getTenantName } from "../../reducers/app";
import { Display} from 'react-bootstrap-icons';
import {
  getToken,
  getLoginStatus,
  loginAsync,
  updateLoginStatus,
  getErrorMessage,
} from "../../reducers/login";
import { getTenantInfo } from "../../reducers/tenant";
import { COMMON_STATUS, SEVERITY_STATUS } from "../../constants/status";
import { Toast } from "primereact/toast";

type Props = {
  setToken: any;
};

export const LoginForm: React.FC<Props> = ({ setToken }) => {
  const dispatch = useAppThunkDispatch();
  const { t, i18n } = useTranslation("common");

  const toast = useRef<any | null>(null);

  const client_name = useSelector(getTenantName);
  const [username, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const token = useSelector(getToken);
  const logged = useSelector(getLoginStatus);
  const errorMessage = useSelector(getErrorMessage);

  const login = (e: any) => {
    e.preventDefault();
    dispatch(
      loginAsync({
        username: username?.toLocaleLowerCase(),
        password: password,
        tenantName: client_name,
      })
    );
  };

  useEffect(()=>{
    console.log(process.env.WEB_URL);
  }, [])
  const handleDesktopVersionClick = () => {
    window.location.href = `${process.env.REACT_APP_WEB_URL}/${client_name}/Account/Login?preferredVersion=desktop`;
  };

  useEffect(() => {
    if (logged === COMMON_STATUS.LOGIN) {
      setToken(token);
    } else if (logged === COMMON_STATUS.UNAUNTHETICATED) {
      toast.current
        ? toast.current?.show({
            severity: SEVERITY_STATUS.ERROR,
            summary: t("NewCart_LoginFailed"),
            detail: t("Controler_Main_Password"),
            life: 3000,
          })
        : "";
      dispatch(updateLoginStatus(COMMON_STATUS.INITIAL));
    }
    else if (logged === COMMON_STATUS.ERROR) {
      toast.current
        ? toast.current?.show({
            severity: SEVERITY_STATUS.ERROR,
            summary: t("NewCart_LoginFailed"),
            detail: errorMessage ,
            life: 3000,
          })
        : "";
      dispatch(updateLoginStatus(COMMON_STATUS.INITIAL));
    }
  }, [dispatch, logged, setToken, t, token]);

  return (
    <>
      <Toast ref={toast} />

      

      <form onSubmit={login} className="flex">
      <div style={{ marginLeft: '20px', alignSelf: 'flex-start' }}>
        <a 
          onClick={handleDesktopVersionClick} 
          style={{ cursor: 'pointer', padding: '2px', color: 'black' }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Display size={30}/> 
            <p style={{ fontSize: '20px', margin: 0 }}>{t("Login_Use_Desktop_Version")}</p>
          </span>
        </a>
      </div>
        {/* <div className="flex"> */}
        <InputText
          id="email"
          placeholder={t("menu_EventEmail")}
          onChange={(e) => setUserName(e.target.value)}
        />
        <Password
          feedback={false}
          id="password"
          placeholder={t("Password")}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          className="p-button login-submit"
          label={t("Login_Log_in")}
          type="submit"
        ></Button>
        {/* </div> */}
      </form>

     
    </>
  );
};
